import { useMemo } from 'react';
import type { DisplayedSubjectQuote } from '../../../../../types';
import { toPendingQuoteRow } from '../../../utils/pendingQuoteRow';

type Props = {
  quotes: DisplayedSubjectQuote[];
};

export function usePendingQuotesSection(props: Props) {
  // Inside the sub-topic, the quote title tells the rows apart.
  const rows = useMemo(() => props.quotes.map((quote) => toPendingQuoteRow(quote, quote.title)), [props.quotes]);

  return { rows };
}
